import React from 'react';
import './popup.css';

interface PopupProps {
    isOpen: boolean;
    isSuccess: boolean;
    message: string;
    updatedUsersStatus: { id: number; name: string; succesfullyUpdated: boolean }[];
    onClose: () => void;
}

const Popup: React.FC<PopupProps> = ({ isOpen, isSuccess, message, updatedUsersStatus, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
            <div className={`popup-content ${isSuccess ? 'success' : 'error'}`}>
                <div className="popup-header">
                    <span className={`popup-icon ${isSuccess ? 'success' : 'error'}`}>
                        {isSuccess ? '✓' : '!'}
                    </span>
                    <h3>{isSuccess ? 'עדכון הושלם' : 'שגיאה בעדכון'}</h3>
                </div>
                <div className="popup-body">
                    <p>{message}</p>
                    {updatedUsersStatus && updatedUsersStatus.length > 0 && (
                        <div className="users-status">
                            <p>סטטוס עדכון משתמשים:</p>
                            <ul>
                                {updatedUsersStatus.map((user, index) => (
                                    <li key={index}>
                                        {user.name}: {user.succesfullyUpdated ? '✅' : '❌'}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div className="popup-close-button-container">
                        <button className="popup-close" onClick={onClose}>
                            סגור
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Popup;
